/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { partNumberStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPartNumber";
import { labelStyle, valueStyle } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

partNumberStyles.labelText = {
    css: css`
        ${labelStyle};
    `,
};

partNumberStyles.valueText = {
    css: css`
        ${valueStyle};
    `,
};
